import moment from "moment";
import * as XLSX from "xlsx";
import { _global } from "../../helpers";
import { changeToTitleCase } from "../../utils/convertionUtils";

export const INBOX_EXPORT_COLUMNS = [
  { header: "Last Message Date", width: 18 },
  { header: "Initial Message Date", width: 20 },
  { header: "Attachment", width: 12 },
  { header: "Member Name", width: 28 },
  { header: "Client Name", width: 28 },
  { header: "Member ID", width: 18 },
  { header: "Vendor", width: 20 },
  { header: "Member Email", width: 34 },
  { header: "Phone", width: 16 },
  { header: "Subject", width: 60 },
];

const DATE_FORMAT = "mm/dd/yyyy";
const pad = (value) => String(value).padStart(2, "0");

// Hyphens stand in for ISO 8601 colons, which Windows does not allow in file names.
export const buildInboxExportFileName = (date = new Date()) => {
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const absOffset = Math.abs(offsetMinutes);
  const stamp =
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}-${pad(date.getMinutes())}-${pad(date.getSeconds())}` +
    `${sign}${pad(Math.floor(absOffset / 60))}-${pad(absOffset % 60)}`;
  return `CSR_Inbox_${stamp}.xlsx`;
};

const toExcelDate = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.startOf("day").toDate() : "";
};

const hasAttachment = (attachments) =>
  (!isNaN(attachments) && attachments > 0) || (Array.isArray(attachments) && attachments.length > 0);

const getMemberName = (conversation, member) => {
  if (conversation.member) {
    const fullName = [conversation.member.firstName, conversation.member.lastName].filter(Boolean).join(" ");
    return changeToTitleCase(fullName) || "";
  }
  return (member && changeToTitleCase(member.name)) || "";
};

export const mapConversationToExportRow = (conversation, member = {}) => {
  const conversationMember = conversation.member || {};
  const lastMessage = conversation.lastMessage || {};
  return [
    toExcelDate(lastMessage.createdTimestamp),
    toExcelDate(conversation.currentMemberRequestInitialMessageDate),
    hasAttachment(lastMessage.attachments) ? "Yes" : "",
    getMemberName(conversation, member),
    member.clientName || conversationMember.clientName || "",
    String(member.sequencedMemberId || conversationMember.sequencedMemberId || ""),
    conversationMember.memberHccId || member.memberHccId ? "HealthRules Payer" : "Javelina",
    member.email || conversationMember.emailAddress || "",
    _global.formatPhoneNumber(member.phone || conversationMember.phoneNumber) || "",
    conversation.topic || "",
  ];
};

export const buildInboxWorkbook = (conversations, member = {}) => {
  const rows = [
    INBOX_EXPORT_COLUMNS.map((column) => column.header),
    ...conversations.map((conversation) => mapConversationToExportRow(conversation, member)),
  ];
  const worksheet = XLSX.utils.aoa_to_sheet(rows, { cellDates: true, dateNF: DATE_FORMAT });
  worksheet["!cols"] = INBOX_EXPORT_COLUMNS.map((column) => ({ wch: column.width }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "CSR Inbox");
  return workbook;
};

export const exportInboxToExcel = (conversations, member = {}, date = new Date()) => {
  const fileName = buildInboxExportFileName(date);
  XLSX.writeFile(buildInboxWorkbook(conversations, member), fileName, { compression: true });
  return fileName;
};
